// --- الواردات القديمة (تم إيقافها بالكامل) ---
/*
import URFAZAPlus from './../assets/Service/M3.jpg'
import PHOSPHOFAZA from './../assets/Service/M14.jpg'
import n1 from './../assets/Service/1n.jpg'
import n2 from './../assets/Service/2n.jpg'
import n3 from './../assets/Service/3.jpg'
import n4 from './../assets/Service/4.jpg'
import n5 from './../assets/Service/5.jpg'
import n6 from './../assets/Service/6.jpg'
import n10 from './../assets/Service/10.jpg'
import n11 from './../assets/Service/11.jpg'
import n12 from './../assets/Service/12.jpg'
import n13 from './../assets/Service/13.jpg'
import n14 from './../assets/Service/14.jpg'
import n15 from './../assets/Service/15.jpg'
import n16 from './../assets/Service/16.jpg'
import n17 from './../assets/Service/17.jpg'
import n18 from './../assets/Service/18.jpg'
import n19 from './../assets/Service/19.jpg'
import n20 from './../assets/Service/20.jpg'
import n21 from './../assets/Service/21.jpg'
import n22 from './../assets/Service/22.jpg'
import n23 from './../assets/Service/23.jpg'
import n24 from './../assets/Service/24.jpg'
import n25 from './../assets/Service/25.jpg'
import n26 from './../assets/Service/26.jpg'
import n27 from './../assets/Service/n27.jpg'
import n28 from './../assets/Service/n28.jpg'
import n29 from './../assets/Service/n29.jpg'
import n30 from './../assets/Service/n30.jpg'
import n31 from './../assets/Service/n31.jpg'
*/

// --- استيراد الصور الجديدة من 1 إلى 41 ---
// import p1 from './../assets/pro/1.jpeg'
import p2 from './../assets/pro/2.jpeg'
import p3 from './../assets/pro/3.jpeg'
import p4 from './../assets/pro/4.jpeg'
import p5 from './../assets/pro/5.jpeg'
import p6 from './../assets/pro/6.jpeg'
import p7 from './../assets/pro/7.jpeg'
import p8 from './../assets/pro/8.jpeg'
import p9 from './../assets/pro/9.jpeg'
import p10 from './../assets/pro/10.jpeg'
import p11 from './../assets/pro/11.jpeg'
// import p12 from './../assets/pro/12.jpeg'
import p13 from './../assets/pro/13.jpeg'
import p14 from './../assets/pro/14.jpeg'
import p15 from './../assets/pro/15.jpeg'
import p16 from './../assets/pro/16.jpeg'
import p17 from './../assets/pro/17.jpeg'
// import p18 from './../assets/pro/18.jpeg'
import p19 from './../assets/pro/19.jpeg'
import p20 from './../assets/pro/20.jpeg'
import p21 from './../assets/pro/21.jpeg'
import p22 from './../assets/pro/22.jpeg'
import p23 from './../assets/pro/23.jpeg'
import p24 from './../assets/pro/24.jpeg'
// import p25 from './../assets/pro/25.jpeg'
import p26 from './../assets/pro/26.jpeg'
import p27 from './../assets/pro/27.jpeg'
import p28 from './../assets/pro/28.jpeg'
import p29 from './../assets/pro/29.jpeg'
// import p30 from './../assets/pro/30.jpeg'
import p31 from './../assets/pro/31.jpeg'
import p32 from './../assets/pro/32.jpeg'
import p33 from './../assets/pro/33.jpeg'
import p34 from './../assets/pro/34.jpeg'
import p35 from './../assets/pro/35.jpeg'
import p36 from './../assets/pro/36.jpeg'
import p37 from './../assets/pro/37.jpeg'
import p38 from './../assets/pro/38.jpeg'
import p39 from './../assets/pro/39.jpeg'
import p40 from './../assets/pro/40.jpeg'
import p41 from './../assets/pro/41.jpeg'
import p42 from './../assets/pro/42.jpeg'
import p43 from './../assets/pro/43.jpeg'
import p44 from './../assets/pro/44.jpeg'
import p45 from './../assets/pro/45.jpeg'
import p46 from './../assets/pro/46.jpeg'
import p47 from './../assets/pro/47.jpeg'
import p48 from './../assets/pro/48.jpeg'
import p49 from './../assets/pro/49.jpeg'
import p50 from './../assets/pro/50.jpeg'
import p51 from './../assets/pro/51.jpeg'

export const products = [
        // { id: 18, imgURL: p1 },
        { id: 19, imgURL: p2 },
        { id: 21, imgURL: p3 },
        { id: 37, imgURL: p4 },
        { id: 17, imgURL: p5 },
        { id: 15, imgURL: p6 },
        { id: 22, imgURL: p7 },
        { id: 23, imgURL: p8 },
        { id: 24, imgURL: p9 },
        { id: 28, imgURL: p10 },
        { id: 29, imgURL: p11 },
        // { id: 30, imgURL: p12 },
        { id: 31, imgURL: p13 },
        { id: 32, imgURL: p14 },
        { id: 33, imgURL: p15 },
        { id: 34, imgURL: p16 },
        { id: 35, imgURL: p17 },
        // { id: 36, imgURL: p18 },
        { id: 38, imgURL: p19 },
        { id: 39, imgURL: p20 },
        { id: 40, imgURL: p21 },
        { id: 41, imgURL: p22 },
        { id: 42, imgURL: p23 },
        { id: 43, imgURL: p24 },
        // { id: 44, imgURL: p25 },
        { id: 45, imgURL: p26 },
        { id: 46, imgURL: p27 },
        { id: 47, imgURL: p28 },
        { id: 48, imgURL: p29 },
        // { id: 49, imgURL: p30 },
        { id: 50, imgURL: p31 },
        { id: 51, imgURL: p32 },
        { id: 52, imgURL: p33 },
        { id: 53, imgURL: p34 },
        { id: 54, imgURL: p35 },
        { id: 55, imgURL: p36 },
        { id: 56, imgURL: p37 },
        { id: 57, imgURL: p38 },
        { id: 58, imgURL: p39 },
        { id: 59, imgURL: p40 },
        { id: 60, imgURL: p41 },
        { id: 61, imgURL: p42 },
        { id: 62, imgURL: p43 },
        { id: 63, imgURL: p44 },
        { id: 64, imgURL: p45 },
        { id: 65, imgURL: p46 },
        { id: 66, imgURL: p47 },
        { id: 67, imgURL: p48 },
        { id: 68, imgURL: p49 },
        { id: 69, imgURL: p50 },
        { id: 70, imgURL: p51 }
];